import { calculateHeaderHeight } from '@vo/js/utils/helpers'

class WindowObserver {
    static instance

    constructor() {
        if (WindowObserver.instance) {
            return WindowObserver.instance
        }

        WindowObserver.instance = this

        this.resizeTimeout = null

        this.init()
    }

    get headerHeight() {
        return calculateHeaderHeight()
    }

    observe() {
        window.addEventListener('resize', this.handleResize.bind(this))
        window.addEventListener('scroll', this.handleResize.bind(this))
    }

    handleResize() {
        clearTimeout(this.resizeTimeout)

        this.resizeTimeout = setTimeout(() => {
            this.update()
        }, 100)
    }

    update() {
        this.updateWindowProperties()
        this.updateHeaderProperties()
        this.updateCountdownBarProperties()
    }

    updateWindowProperties() {
        document.documentElement.style.setProperty('--vw', `${document.body.clientHeight / 100}px`)
        document.documentElement.style.setProperty('--vh', `${document.body.clientHeight / 100}px`)
        document.documentElement.style.setProperty('--viewport-width', `${window.innerWidth}px`)
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
        document.documentElement.style.setProperty('--viewport-minus-header-height', `${window.innerHeight - this.headerHeight}px`)
    }

    updateHeaderProperties() {
        document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`)
    }

    updateCountdownBarProperties() {
        const countdownBar = document.querySelector('#countdown')
        if (countdownBar) {
            const countdownBarHeight = countdownBar.offsetHeight
            document.documentElement.style.setProperty('--countdown-bar-height', `${countdownBarHeight}px`)
        }
    }

    init() {
        this.update()
        this.observe()
    }

    static create() {
        return new WindowObserver()
    }
}

export default WindowObserver
